import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
 
  container: {
    marginBottom: 100,
  },
 

  onrenderColumnStack: {
    height: 25,
  },
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  textAlignEnd: {
    textAlign: 'end',
  },
  columnHeight: {
    height: 25,
  },
}));
